module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-card', {
    staticClass: "card",
    staticStyle: {
      "margin": "1rem"
    }
  }, [_c('md-card-content', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticStyle: {
      "position": "absolute"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color heght-1px",
    staticStyle: {},
    on: {
      "click": _vm.previousContainerView
    }
  }, [_vm._v("« Back")])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center"
  }, [_c('h2', [_vm._v(_vm._s(_vm.editVar.FormVal) + " Container Details")])])], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Container Size-Type (eg...40-COLLAPSIBLE FLAT RACK)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "containerType",
      "name": "containerType"
    },
    model: {
      value: (_vm.containerDetail.containerType),
      callback: function($$v) {
        _vm.$set(_vm.containerDetail, "containerType", $$v)
      },
      expression: "containerDetail.containerType"
    }
  })], 1), _vm._v(" "), (!_vm.containerDetail.containerType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.containerTypeError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "ml-3",
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Max Payload (in Kg)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "maxPayload",
      "name": "maxPayload"
    },
    model: {
      value: (_vm.containerDetail.maxPayload),
      callback: function($$v) {
        _vm.$set(_vm.containerDetail, "maxPayload", $$v)
      },
      expression: "containerDetail.maxPayload"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_c('u', [_vm._v("Internal Dimension")])])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Length (in meters)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "internalDimLength",
      "name": "internalDimLength"
    },
    on: {
      "keyup": function($event) {
        _vm.findArea()
      }
    },
    model: {
      value: (_vm.containerDetail.internalDimLength),
      callback: function($$v) {
        _vm.$set(_vm.containerDetail, "internalDimLength", $$v)
      },
      expression: "containerDetail.internalDimLength"
    }
  })], 1), _vm._v(" "), (!_vm.containerDetail.internalDimLength) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.internalDimLengthError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Width (in meters)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "internalDimWidth",
      "name": "internalDimWidth"
    },
    on: {
      "keyup": function($event) {
        _vm.findArea()
      }
    },
    model: {
      value: (_vm.containerDetail.internalDimWidth),
      callback: function($$v) {
        _vm.$set(_vm.containerDetail, "internalDimWidth", $$v)
      },
      expression: "containerDetail.internalDimWidth"
    }
  })], 1), _vm._v(" "), (!_vm.containerDetail.internalDimWidth) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.internalDimWidthError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Height (in meters)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "internalDimHeight",
      "name": "internalDimHeight"
    },
    model: {
      value: (_vm.containerDetail.internalDimHeight),
      callback: function($$v) {
        _vm.$set(_vm.containerDetail, "internalDimHeight", $$v)
      },
      expression: "containerDetail.internalDimHeight"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15 "
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Area(in meters)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "internalDimHeight",
      "name": "internalDimHeight",
      "disabled": ""
    },
    model: {
      value: (_vm.containerDetail.area),
      callback: function($$v) {
        _vm.$set(_vm.containerDetail, "area", $$v)
      },
      expression: "containerDetail.area"
    }
  })], 1), _vm._v(" "), (!_vm.containerDetail.area) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.areaError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_c('u', [_vm._v("Select Other Dimensions")])])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "selectDimension"
    }
  }, [_vm._v("Select Dimension")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.otherDimensionList,
      "option-value": "otherDimensionV",
      "option-text": "otherDimensionT",
      "placeholder": "Select Other Dimension"
    },
    model: {
      value: (_vm.containerDetail.otherDimension),
      callback: function($$v) {
        _vm.$set(_vm.containerDetail, "otherDimension", $$v)
      },
      expression: "containerDetail.otherDimension"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.containerDetail.otherDimension == 'Door') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Width (in meters)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "doorWidth",
      "name": "doorWidth"
    },
    model: {
      value: (_vm.containerDetail.doorWidth),
      callback: function($$v) {
        _vm.$set(_vm.containerDetail, "doorWidth", $$v)
      },
      expression: "containerDetail.doorWidth"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Height (in meters)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "doorHeight",
      "name": "doorHeight"
    },
    model: {
      value: (_vm.containerDetail.doorHeight),
      callback: function($$v) {
        _vm.$set(_vm.containerDetail, "doorHeight", $$v)
      },
      expression: "containerDetail.doorHeight"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.containerDetail.otherDimension == 'Roof') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Length (in meters)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "roofLength",
      "name": "roofLength"
    },
    model: {
      value: (_vm.containerDetail.roofLength),
      callback: function($$v) {
        _vm.$set(_vm.containerDetail, "roofLength", $$v)
      },
      expression: "containerDetail.roofLength"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Height (in meters)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "roofHeight",
      "name": "roofHeight"
    },
    model: {
      value: (_vm.containerDetail.roofHeight),
      callback: function($$v) {
        _vm.$set(_vm.containerDetail, "roofHeight", $$v)
      },
      expression: "containerDetail.roofHeight"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.containerDetail.otherDimension == 'OutSide') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Length (in meters)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "outSideLength",
      "name": "outSideLength"
    },
    model: {
      value: (_vm.containerDetail.outSideLength),
      callback: function($$v) {
        _vm.$set(_vm.containerDetail, "outSideLength", $$v)
      },
      expression: "containerDetail.outSideLength"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_c('u', [_vm._v("Select Capacity")])])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "selectCapacity"
    }
  }, [_vm._v("Select Capacity")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.selectCapacityList,
      "option-value": "selectCapacityV",
      "option-text": "selectCapacityT",
      "placeholder": "Select Capacity"
    },
    model: {
      value: (_vm.containerDetail.selectCapacity),
      callback: function($$v) {
        _vm.$set(_vm.containerDetail, "selectCapacity", $$v)
      },
      expression: "containerDetail.selectCapacity"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.containerDetail.selectCapacity == 'cubicCapacity') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Cubic Capacity")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "cubicCapacity",
      "name": "cubicCapacity"
    },
    model: {
      value: (_vm.containerDetail.cubicCapacity),
      callback: function($$v) {
        _vm.$set(_vm.containerDetail, "cubicCapacity", $$v)
      },
      expression: "containerDetail.cubicCapacity"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.containerDetail.selectCapacity == 'Inside') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Length (in meters)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "insideLength",
      "name": "insideLength"
    },
    model: {
      value: (_vm.containerDetail.insideLength),
      callback: function($$v) {
        _vm.$set(_vm.containerDetail, "insideLength", $$v)
      },
      expression: "containerDetail.insideLength"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Width (in meters)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "insideWidth",
      "name": "insideWidth"
    },
    model: {
      value: (_vm.containerDetail.insideWidth),
      callback: function($$v) {
        _vm.$set(_vm.containerDetail, "insideWidth", $$v)
      },
      expression: "containerDetail.insideWidth"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "mrgtop-button justify-content-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color mrgtop-2per",
    attrs: {
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addVehicleSize
    }
  }, [_vm._v(_vm._s(_vm.editVar.Inputval))]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2471fbbf","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/containerMaster/containerType.vue
// module id = 2466
// module chunks = 0